export default function CheckboxInput({name, disabled, dataId, value, status, register, type}) {
    return (
        <div>
            <input 
                className="filter-entrance__input" 
                type="checkbox" 
                name={name}
                id={name}
                data-id={dataId} 
                disabled={disabled}
                defaultChecked={type !== 'flat'}
                {...register(name)}
            />
            <label className="filter-entrance__item" htmlFor={name}>
                <p className="filter-entrance__value">{value}</p>
                { status && <div className="filter-floor__status">{status}</div> }
            </label>
        </div>
    );
}